// Typed wrapper around the /v1/audit-log read endpoint.

import type { AuditLogListResponse } from '@cortex/shared';
import type { ApiClient } from '../api-client.js';

export const auditLogApi = {
  list: (api: ApiClient, opts: { limit?: number; action?: string } = {}) => {
    const params = new URLSearchParams();
    if (opts.limit !== undefined) params.set('limit', String(opts.limit));
    if (opts.action !== undefined && opts.action.length > 0) {
      params.set('action', opts.action);
    }
    const qs = params.toString();
    return api.get<AuditLogListResponse>(
      qs.length > 0 ? `/v1/audit-log?${qs}` : '/v1/audit-log',
    );
  },
} as const;

export const AUDIT_LOG_QUERY_KEY = ['audit-log'] as const;
export const auditLogFilterQueryKey = (action: string | undefined) =>
  ['audit-log', action ?? null] as const;
